import { v4 as uuid } from 'uuid'

// Only an opaque key is stored, never the receipt, contacts or payment details.
const memory=new Map()
const storageKey=(scope)=>`pixelcrm_fiscal_pending:${scope}`
export function pendingCheckoutKey(scope) {
    try {const saved=sessionStorage.getItem(storageKey(scope));if(saved)return saved}catch(_){/* Session storage may be unavailable. */}
    return memory.get(scope) || ''
}
export function checkoutKey(scope) {
    const key=pendingCheckoutKey(scope) || uuid()
    memory.set(scope,key)
    try {sessionStorage.setItem(storageKey(scope),key)}catch(_){/* In-memory recovery remains available. */}
    return key
}
export function clearCheckoutKey(scope) {
    memory.delete(scope)
    try {sessionStorage.removeItem(storageKey(scope))}catch(_){/* Nothing else to remove. */}
}
